// Shared top chrome: five equal buttons — Home, Profile, Treats, Shop, Back.

import React from "react";
import StoreIcon from "./StoreIcon";
import TreatIcon from "./TreatIcon";
import { clampTreats, formatTreats } from "../utils/treats";

const OverlayTopBar = ({
    onHome,
    onProfile,
    onStore,
    onTreats,
    onLeaderboards: _onLeaderboards,
    onBack,
    storeUnlocked = false,
    leaderboardsUnlocked: _leaderboardsUnlocked = false,
    treats = null,
    className = "",
    variant = "inline",
}) => {
    const isFixed = variant === "fixed";
    const showTreats = treats != null;
    const showHome =
        typeof onBack === "function" && typeof onHome === "function";
    const openTreats =
        typeof onTreats === "function"
            ? onTreats
            : typeof onStore === "function"
              ? onStore
              : undefined;

    const homeButton =
        showHome ? (
            <button
                type="button"
                className="overlayTopBar__button"
                onClick={onHome}
            >
                Home
            </button>
        ) : null;

    const profileButton =
        typeof onProfile === "function" ? (
            <button
                type="button"
                className="overlayTopBar__button"
                onClick={onProfile}
            >
                Profile
            </button>
        ) : null;

    const treatsButton = showTreats ? (
        <button
            type="button"
            className="overlayTopBar__button overlayTopBar__treats"
            onClick={storeUnlocked ? openTreats : undefined}
            disabled={!storeUnlocked || typeof openTreats !== "function"}
            aria-label={formatTreats(treats)}
            title={
                storeUnlocked
                    ? "Open Treats in the Store"
                    : "Treats — Store unlocks after Story Level 2"
            }
        >
            <TreatIcon className="overlayTopBar__treatIcon" title="" />
            {clampTreats(treats).toLocaleString("en-US")}
        </button>
    ) : null;

    const storeButton =
        typeof onStore === "function" ? (
            <button
                type="button"
                className="overlayTopBar__button overlayTopBar__button--shop"
                onClick={onStore}
                disabled={!storeUnlocked}
                aria-disabled={!storeUnlocked}
                aria-label={
                    storeUnlocked
                        ? "Shop"
                        : "Shop locked — clear Story Level 2"
                }
                title={
                    storeUnlocked
                        ? "Open the Shop"
                        : "Clear Story Level 2 to unlock the Shop"
                }
            >
                <StoreIcon className="overlayTopBar__icon" title="" />
                <span className="overlayTopBar__shopLabel">Shop</span>
            </button>
        ) : null;

    const backButton =
        typeof onBack === "function" ? (
            <button
                type="button"
                className="overlayTopBar__button"
                onClick={onBack}
            >
                Back
            </button>
        ) : null;

    return (
        <div
            className={`overlayTopBar overlayTopBar--equal${
                isFixed ? " overlayTopBar--fixed" : ""
            }${className ? ` ${className}` : ""}`}
        >
            {homeButton}
            {profileButton}
            {treatsButton}
            {storeButton}
            {backButton}
        </div>
    );
};

export default OverlayTopBar;
